<template>
<!--  <el-radio-group v-model="selectValue" @change="change">
    <el-radio v-for="item in optionsList" :key="item[valueKey]" :label="item[valueKey]">
      {{item[labelKey]}}
    </el-radio>
  </el-radio-group> -->
  <van-field name="radio" :label="dModel.label">
    <template #input>
      <van-radio-group v-model="selectValue" direction="horizontal"  @change="change">
        <van-radio v-for="item in optionsList" :key="item[valueKey]"  :name="item[valueKey]">{{item[labelKey]}}</van-radio>
      </van-radio-group>
    </template>
  </van-field>
</template>

<script>
  import formDesignMixins from './mixins/formDesignMixins'
  export default {
    name: "DesignRadio",
    data() {
      return {
        selectValue: "",
        labelKey: "label", // label对应得属性key
        valueKey: "value", // value对应的属性key
        optionsList: [],
      };
    },
    mixins: [formDesignMixins],
    props: {
      value: {},
      options: {
        type: Object,
        default: function() {
          return {
            disabled: false, //是否禁用
            hidden: false, // 是否隐藏，false显示，true隐藏
            defaultValue: "", // 默认值 
            dynamic: 0, // 数据获取方式
            tooptip: '', // 提示
            remoteFunc: '', //远程获取数据链接
            dataPath: '',
            remoteValue: '',
            remoteLabel: '',
            linkage: false,
            options: [{
                value: "1",
                label: "选项1"
              },
              {
                value: "2",
                label: "选项2"
              }
            ]
          }
        }
      }
    },
    methods: {
      change: function(selVal) {

        this.$emit('input', selVal)
      },
      //获得下拉列表
      initData: function() {
        let that = this
        // dynamic 为静态下拉，数据从配置中去抓取
        if (that.options.dynamic == 0) {
          that.optionsList = that.options.options
          return;
        }

        // dynamic 不为0 , 动态下拉
        this.valueKey = that.options.remoteValue
        this.labelKey = that.options.remoteLabel
        // 根据模型对象，获得远程数据
        let promiseOptions = that.$designUtils.getRemoteData(that.options)
        promiseOptions.then(data => {
          // 赋值
          that.optionsList = data
        })
      }
    },
    watch: {
      value(nv) {
        this.selectValue = nv
      },
    },
    mounted: function() {

      this.selectValue = this.value
      this.initData()
    },
  };
</script>

<style scoped="scoped">

</style>
